import { render, staticRenderFns } from "./Rococo.vue?vue&type=template&id=2c6abda7&scoped=true&"
import script from "./Rococo.vue?vue&type=script&lang=js&"
export * from "./Rococo.vue?vue&type=script&lang=js&"
import style0 from "./Rococo.vue?vue&type=style&index=0&id=2c6abda7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6abda7",
  null
  
)

export default component.exports